var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Form',{attrs:{"scheme":_vm.scheme,"method-fetch-data":_vm.methods.fetchData,"method-update-data":_vm.methods.updateData,"method-update-scheme":_vm.methods.updateScheme,"is-edit-settings":true,"send-all-form":true}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }